import {
  REQUEST_CUSTOMERS,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  REQUEST_CUSTOMERS_PAGINATE,
  FETCH_CUSTOMERS_PAGINATE_SUCCESS,
  FETCH_CUSTOMERS_PAGINATE_FAILURE,
  REQUEST_CUSTOMERS_STATUS,
  FETCH_CUSTOMERS_STATUS_SUCCESS,
  FETCH_CUSTOMERS_STATUS_FAILURE,
  SELECT_CUSTOMER,
  RESET_CURRENT_CUSTOMER,
  REQUEST_CREATING_CUSTOMER,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILURE,
  REQUEST_EDITING_CUSTOMER,
  EDIT_CUSTOMER_SUCCESS,
  EDIT_CUSTOMER_FAILURE,
  REQUEST_CUSTOMER_DETAIL,
  FETCH_CUSTOMER_DETAIL_SUCCESS,
  FETCH_CUSTOMER_DETAIL_FAILURE,
  REQUEST_CUSTOMER_CREDIT_BY_DATE,
  FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS,
  FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE,
  ATTACH_DOCUMENT,
  ATTACH_DOCUMENT_SUCCESS,
  ATTACH_DOCUMENT_FAILURE,
  FETCH_SALES_INVOICE_DETAIL_SUCCESS,
  REQUEST_CUSTOMERS_OPTIONS,
  FETCH_CUSTOMERS_OPTIONS_SUCCESS,
  FETCH_CUSTOMERS_OPTIONS_FAILURE,
  FETCH_CUSTOMERS_BUYER_LIST,
} from '../actions/type';

const INITIAL_STATE = {
  all: [],
  customerTotalPages: null,
  customerTotalCount: null,
  currentCustomer: null,
  currentCustomerDetail: null,
  isLoading: false,
  error: null,
  detailIsLoading: false,
  detailError: null,
  isCreating: false,
  createError: null,
  created: false,
  isEditing: false,
  editError: null,
  edited: false,
  customerCreditLines: [],
  customerCreditLinesIsLoading: false,
  customerCreditLinesError: null,
  customersStatuses: [],
  customersStatusesIsLoading: false,
  customersStatusesError: null,
  isAttachingDocument: false,
  options: [],
  loadingOptions: false,
  buyerList:[],
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_CUSTOMERS:
      return { ...state, error: null, isLoading: true };
    case FETCH_CUSTOMERS_SUCCESS:// return list of posts and make loading = false
      return { ...state, all: action.payload.data, error: null, isLoading: false };
    // return error and make loading = false
    case FETCH_CUSTOMERS_FAILURE: {
      const error = action.payload || { message: action.payload.message }; // 2nd one is network or server down errors
      alert(JSON.stringify(error));
      return { ...state, all: [], error: error, isLoading: false };
    }

    case REQUEST_CUSTOMERS_PAGINATE:
      return { ...state, error: null, isLoading: true };
    case FETCH_CUSTOMERS_PAGINATE_SUCCESS:
      return { 
        ...state, 
        all: action.payload.data.record, 
        customerTotalPages: action.payload.data.pages,
        customerTotalCount: action.payload.data.count,
        error: null, 
        isLoading: false };
    case FETCH_CUSTOMERS_PAGINATE_FAILURE: {
      const error = action.payload || { message: action.payload.message };
      alert(JSON.stringify(error));
      return { ...state, all: [], error: error, isLoading: false };
    }

    case SELECT_CUSTOMER:
      return { ...state, currentCustomer: action.payload };
    case RESET_CURRENT_CUSTOMER:
      return { ...state, currentCustomer: null, currentCustomerDetail: null };
    case REQUEST_CREATING_CUSTOMER:
      return { ...state, isCreating: true, createError: null, created: false };
    case CREATE_CUSTOMER_SUCCESS:
      return { ...state, isCreating: false, createError: null, created: true };
    case CREATE_CUSTOMER_FAILURE: {
      const createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
      alert(JSON.stringify(createError));
      return { ...state, isCreating: false, createError: createError, created: false };
    }
    case REQUEST_EDITING_CUSTOMER:
      return { ...state, isEditing: true, editError: null, edited: false };
    case EDIT_CUSTOMER_SUCCESS:
      return { ...state, isEditing: false, editError: null, edited: true };
    // 2nd term stands for network or server down errors
    case EDIT_CUSTOMER_FAILURE: {
      const editError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(editError));
      return { ...state, isEditing: false, editError: editError, edited: false };
    }
    case REQUEST_CUSTOMER_DETAIL:
      return { ...state, detailError: null, detailIsLoading: true };
    // return list of posts and make loading = false
    case FETCH_CUSTOMER_DETAIL_SUCCESS:
      return { ...state, currentCustomerDetail: action.payload.data, detailError: null, detailIsLoading: false };
    // return error and make loading = false
    case FETCH_CUSTOMER_DETAIL_FAILURE: {
      const detailError = action.payload || { message: action.payload.message }; // 2nd one is network or server down errors
      return { ...state, all: [], detailError: detailError, detailIsLoading: false };
    }
    case REQUEST_CUSTOMER_CREDIT_BY_DATE:
      return { ...state, customerCreditLinesIsLoading: true, customerCreditLinesError: null };
    case FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS:
      return { ...state, customerCreditLines: action.payload.data, customerCreditLinesIsLoading: false };
    case FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE: {
      const customerCreditLinesError = action.payload.data || { message: action.payload.message };
      return { ...state, customerCreditLinesError: customerCreditLinesError, customerCreditLinesIsLoading: false };
    }
    case REQUEST_CUSTOMERS_STATUS:
      return { ...state, customersStatuses: [], customersStatusesIsLoading: true, customersStatusesError: null };
    case FETCH_CUSTOMERS_STATUS_SUCCESS:
      return { ...state, customersStatuses: action.payload.data, customersStatusesIsLoading: false };
    case FETCH_CUSTOMERS_STATUS_FAILURE: {
      const customersStatusesError = action.payload.data || { message: action.payload.message };
      return { ...state, customersStatusesError: customersStatusesError, customersStatusesIsLoading: false };
    }
    case ATTACH_DOCUMENT:
      return { ...state, isAttachingDocument: true, attachDocumentError: null, attachDocumentSuccess: false };
    case ATTACH_DOCUMENT_SUCCESS:
      return { ...state, isAttachingDocument: false, attachDocumentError: null, attachDocumentSuccess: true };
    case ATTACH_DOCUMENT_FAILURE: {
      const attachDocumentError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(attachDocumentError))
      return { ...state, isAttachingDocument: false, attachDocumentError, attachDocumentSuccess: false };
    }
    case FETCH_SALES_INVOICE_DETAIL_SUCCESS:
      return { ...state, currentSalesInvoice: action.payload.data, customersStatusesIsLoading: false };
    case REQUEST_CUSTOMERS_OPTIONS:
      return { ...state, error: null, loadingOptions: true};
    case FETCH_CUSTOMERS_OPTIONS_SUCCESS:
      return { ...state, options: action.payload.data, error: null, loadingOptions: false };
    case FETCH_CUSTOMERS_OPTIONS_FAILURE: {
      const error = action.payload || { message: action.payload.message };
      alert(JSON.stringify(error));
      return { ...state, options: [], error: error, loadingOptions: false };
    }
    case FETCH_CUSTOMERS_BUYER_LIST: {
      return {
        ...state,
        buyerList: action.payload.buyerList,
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/customers_reducer.js